import React from "react";
import { Button as AntButton } from "antd";
import "./buttons.css";
import { BaseButtonProps } from "antd/es/button/button";


interface ButtonProps extends BaseButtonProps {
  ref?: React.Ref<HTMLButtonElement>;
  /**
   * Additional props to pass down to the html button element
   * @default {}
   */
  rest?: any;
  /**
   * Function to run when the button is clicked
   * @default undefined
   */
  onClick?: (e: any) => void;
  /**
   * Function to run when the button is pressed down
   * @default undefined
   */
  onMouseDown?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  /**
   * The type of button to render
   * @default "button"
   */
  htmlType?: "button" | "submit" | "reset";
  /**
   * Whether to show a title when the button is hovered
   * @default false
   */
  hoverTitle?: boolean;
  id?: string;
}

const Button = ({ type = 'default', id, hoverTitle = false, htmlType="button", 'data-tour': dataTour, ...rest }: ButtonProps) => {
  const [isHovered, setIsHovered] = React.useState(false);
  const [showTitle, setShowTitle] = React.useState(false);
  const timerRef = React.useRef<NodeJS.Timeout | null>(null);

  const handleMouseOver = () => {
    setIsHovered(true);
    if (timerRef.current) clearTimeout(timerRef.current);
    setShowTitle(true);
  };

  const handleMouseOut = () => {
    setIsHovered(false);
    timerRef.current = setTimeout(() => setShowTitle(false), 3000);
  };

  React.useEffect(() => {
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);

  return (
    <AntButton
      htmlType={htmlType}
      type={type}
      onMouseOver={handleMouseOver}
      onMouseOut={handleMouseOut}
      data-tour={dataTour}
      {...rest}
      id={id}
    >
      {hoverTitle ? (isHovered || showTitle) ? rest.children : null : rest.children}
    </AntButton>
  )
};

export { Button };
